module.exports = __webpack_public_path__ + "static/media/e.2f3726f4.m4a";